"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSession = void 0;
const react_1 = require("react");
const react_2 = require("next-auth/react");
// eslint-disable-next-line import/no-unresolved
const client_1 = require("@side/identity-token/client");
const jwt_decode_1 = require("jwt-decode");
const handle_token_refresh_error_1 = require("../utils/handle-token-refresh-error");
const useSession = (options) => {
    const { allowExpiredToken } = options ?? {};
    const session = (0, react_2.useSession)(options);
    return (0, react_1.useMemo)(() => {
        if (session.data) {
            const adminScopes = (0, jwt_decode_1.jwtDecode)(session.data.accessToken ?? '').adminScopes ||
                [];
            const hasScopesFn = (expectedScopes) => {
                return (0, client_1.hasScopes)(adminScopes, expectedScopes);
            };
            session.data.hasScopes = hasScopesFn;
        }
        // handleTokenRefreshError will return null for the session data
        // if there is a token refresh error
        if (session.data && (0, handle_token_refresh_error_1.hasRefreshTokenError)(session.data)) {
            const data = (0, handle_token_refresh_error_1.handleTokenRefreshError)(session.data, allowExpiredToken);
            // The return type of useSession would be SessionContextValue<R>, but since we are re-writing
            // the value of session.status it no longer conforms to that types conditional logic.
            const status = 
            // if handleTokenRefreshError returns null, but next-auth says it is authenticated,
            // we need to treat the session as unauthenticated until the logout page is loaded
            session.status === 'authenticated' && !data
                ? 'unauthenticated'
                : session.status;
            return { status, data, update: session.update };
        }
        return {
            ...session,
        };
    }, [session.status, session.data, session.update, allowExpiredToken]);
};
exports.useSession = useSession;
